export const getLocale = (state: any): string => {
  return state.common.locale
}
